import type { Signal } from '@angular/core'

import {
  type ResolvedConnectionOptions,
  requireConnectionUrl,
  resolveConnectionOptions,
} from '@flowx/core-sdk'

type ConnectionInputs<Token extends string | null> = {
  baseUrl: Signal<string | undefined>
  apiUrl: Signal<string | undefined>
  assetsBaseUrl: Signal<string | undefined>
  staticAssetsPath: Signal<string | undefined>
  accessToken: Signal<Token | undefined>
  authToken: Signal<Token | undefined>
  enginePath?: Signal<string | undefined>
  processApiPath?: Signal<string | undefined>
}

// Reads a renderer's connection inputs, both names of each, under core's internal names.
// One of each URL pair is required, as the old required apiUrl and staticAssetsPath inputs
// were; the task manager alone takes the assets URL as optional.
export const resolveConnectionInputs = <Token extends string | null>(
  inputs: ConnectionInputs<Token>,
  { assetsBaseUrlRequired = true }: { assetsBaseUrlRequired?: boolean } = {}
): ResolvedConnectionOptions<Token> => {
  const options = resolveConnectionOptions({
    baseUrl: inputs.baseUrl(),
    apiUrl: inputs.apiUrl(),
    enginePath: inputs.enginePath?.(),
    processApiPath: inputs.processApiPath?.(),
    assetsBaseUrl: inputs.assetsBaseUrl(),
    staticAssetsPath: inputs.staticAssetsPath(),
    accessToken: inputs.accessToken(),
    authToken: inputs.authToken(),
  })
  return {
    ...options,
    apiUrl: requireConnectionUrl('baseUrl', options.apiUrl),
    staticAssetsPath: assetsBaseUrlRequired
      ? requireConnectionUrl('assetsBaseUrl', options.staticAssetsPath)
      : options.staticAssetsPath,
  }
}
